<template>
  <v-data-table
    hide-default-footer
    class="elevation-4 mb-2"
    no-data-text="Nenhum item disponível"
    :loading="isGetAlteracoesHistoricoLoading"
    loading-text="Carregando dados..."
    :headers="headers"
    :items="items"
    :item-class="cursorPointer"
    @click:row="selecionarItem"
  >
    <template #item.dataCadastro="{ item }">
      {{ functions.converterDateTimeStringEmLocaleDateTimeString(item.dataCadastro) }}
    </template>
  </v-data-table>
</template>

<script>
import { converterDateTimeStringEmLocaleDateTimeString } from '@/utils/dateTime'

export default {
  emits: ['select-item'],

  props: {
    items: {
      type: Array,
      required: true,
    },
    selectItem: {
      type: Function,
      required: true,
    },
    isGetAlteracoesHistoricoLoading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const headers = [
      { text: 'Data - Hora', value: 'dataCadastro' },
      { text: 'Usuário', value: 'usuarioAlteracao' },
    ]

    function selecionarItem(item) {
      props.selectItem(item)
    }

    return {
      headers,
      functions: {
        converterDateTimeStringEmLocaleDateTimeString,
      },
      selecionarItem,
      cursorPointer: () => 'cursor-pointer',
    }
  },
}
</script>
